
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/[category]",
      function () {
        return require("private-next-pages/[city]/[category]/index.tsx");
      }
    ]);
  